import {
  McleodCommodityOption,
  McleodReferenceNumberOption,
  ValueLabelOption,
} from 'pages/QuoteView/LoadBuilding/McleodSectionForms/types';

export const buchananTransportTypeOptions: ValueLabelOption[] = [
  { value: '10A', label: '10 Axle Trailer' },
  { value: '13A', label: '13 Axel Trailer' },
  { value: 'DR20', label: "20' DRAY" },
  { value: 'HT20', label: "20' HOTSHOT" },
  { value: '20TR', label: "20' TRI-AXLE" },
  { value: '26', label: "26' STRAIGHT TRUCK" },
  { value: 'V28', label: '28 Foot Van' },
  { value: '3D', label: '3 AXLE DOUBLE DROP' },
  { value: '3A', label: '3 AXLE FLATBED' },
  { value: '3AS', label: '3 AXLE STEP' },
  { value: '3ST', label: '3 AXLE STRETCH' },
  { value: 'HT30', label: "30' HOTSHOT" },
  { value: '4A', label: '4 Axel Flatbed' },
  { value: 'DR40', label: "40' DRAY" },
  { value: 'HT40', label: "40' HOTSHOT" },
  { value: 'FL48', label: "48' Flatbed" },
  { value: 'SP48', label: "48' Stepdeck" },
  { value: '53FS', label: '53 Flat or Step' },
  { value: '3S53', label: "53' 3 AXLE STEPDECK" },
  { value: 'CON', label: "53' CONESTOGA" },
  { value: 'FL53', label: "53' Flatbed" },
  { value: 'SP53', label: "53' Stepdeck" },
  { value: 'DV53', label: "53' VAN W/D-RINGS" },
  { value: 'V57', label: "57' VAN" },
  { value: '8A', label: '8 Axle Trailer' },
  { value: 'AIR', label: 'AIR FREIGHT' },
  { value: 'TKAL', label: 'AL TANK TRAILER' },
  { value: 'AFL', label: 'ALUMINUM FLATBED' },
  { value: 'AS', label: 'ALUMINUM STEP' },
  { value: 'D53', label: "Auto Drop Van 53'" },
  { value: 'CAR', label: 'AUTO TRANSPORTER' },
  { value: 'BT', label: 'B-TRAIN' },
  { value: 'BEAM', label: 'BEAM INSERT' },
  { value: 'AC', label: 'Car Hauler Trailers' },
  { value: 'CRV', label: 'CARGO VAN' },
  { value: 'CN', label: 'Conestoga (DAT)' },
  { value: 'CV', label: 'Conveyor (DAT)' },
  { value: 'CSD', label: 'CURTAIN SIDE SINGLE DROP' },
  { value: 'CUR', label: 'CURTAINSIDE or CONESTOGA' },
  { value: 'DECK', label: 'DECK INSERT' },
  { value: 'DHFH', label: 'DOCK HIGH FLATBED WITH HEADBOARD ONLY' },
  { value: 'DOLL', label: 'DOLLY' },
  { value: 'DTD', label: 'DOOR TO DOOR' },
  { value: 'DD', label: 'Double Drop (DAT)' },
  { value: 'DDC', label: 'DOUBLE DROP CONESTOGA' },
  { value: 'DDS', label: 'DOUBLE DROP STRETCH' },
  { value: 'LA', label: 'Double Drop Trailers' },
  { value: 'DRAY', label: 'DRAY' },
  { value: 'DDT', label: 'Drop Deck Trailers' },
  { value: 'DVC', label: 'DRY VAN OR CURTAINSIDE' },
  { value: 'DLD', label: 'DUAL LANE DOLLIES' },
  { value: 'DT', label: 'Dumps Trailers' },
  { value: 'DUN', label: 'DUNNAGE' },
  { value: 'ELEV', label: 'ELECTRONIC VAN' },
  { value: 'V53R', label: 'ENCLOSED VAN WITH RAMPS' },
  { value: 'DUMP', label: 'END DUMP' },
  { value: 'FS53', label: 'FL OR SD 53FT' },
  { value: 'FAT', label: 'FLAT AIR RIDE W/ TARPS' },
  { value: 'FLT', label: 'FLAT LTL' },
  { value: 'FFWS', label: 'FLAT OR FLAT W/ SIDES' },
  { value: 'FLS', label: 'FLAT OR STEP' },
  { value: 'FLV', label: 'FLAT OR VAN' },
  { value: 'FAR', label: 'FLAT W/ AIR RIDE' },
  { value: 'FC53', label: 'FLAT, STEP, OR CONESTOGA' },
  { value: 'FSD', label: 'FLAT, STEP, OR DOUBLE DROP' },
  { value: 'FL', label: 'FLATBED' },
  { value: 'FN', label: 'Flatbed Conestoga (DAT)' },
  { value: 'FZ', label: 'FLATBED HAZ-MAT' },
  { value: 'FLC', label: 'FLATBED OR CONESTOGA' },
  { value: 'FLH', label: 'FLATBED OR HOT SHOT' },
  { value: 'FO', label: 'Flatbed Over-dimension' },
  { value: 'FST', label: 'FLATBED SMOKE TARP' },
  { value: 'FLA', label: 'FLATBED TARPED' },
  { value: 'FTM', label: 'FLATBED TEAM' },
  { value: 'F', label: 'Flatbed Trailers' },
  { value: 'FWS', label: 'FLATBED W/ SIDES' },
  { value: 'FC', label: 'Flatbed with chains (DAT)' },
  { value: 'FSC', label: 'FLATBED, STEPDECK OR CONESTOGA' },
  { value: 'FSH', label: 'FLATBED, STEPDECK OR HOT SHOT' },
  { value: 'FLIP', label: 'FLIP AXLE' },
  { value: 'LOG', label: 'Forestry Trailers' },
  { value: 'HB', label: 'Grain Trailers,Hopper Bottom' },
  { value: 'GR45', label: 'GREIF-VAN' },
  { value: 'GR48', label: 'GREIF-VAN' },
  { value: 'GR53', label: 'GREIF-VAN' },
  { value: 'GR57', label: 'GREIF-VAN' },
  { value: 'HOT', label: 'HOTSHOT' },
  { value: 'HOTT', label: 'HOTSHOT WITH TARPS' },
  { value: 'IR', label: 'Insulated Van or Reefer (DAT)' },
  { value: 'INT', label: 'INTERMODAL' },
  { value: 'VA', label: 'Intermodal Trailers' },
  { value: 'JEEP', label: 'JEEP' },
  { value: 'LAND', label: 'LANDOLL' },
  { value: 'VG', label: 'LIFTGATE VAN' },
  { value: 'VV', label: 'Livestock Trailers' },
  { value: 'LV', label: 'LOGISTICS VAN' },
  { value: 'LSD', label: 'LOW PROFILE STEPDECK' },
  { value: 'LR', label: 'Lowboy or RGN (DAT)' },
  { value: 'LO', label: 'Lowboy Overdimension (DAT)' },
  { value: 'LB', label: 'Lowboy Trailers' },
  { value: 'MAXI', label: 'Maxi Flatbed' },
  { value: 'MINI', label: 'MINIFLOAT' },
  { value: '9A', label: 'NINE AXLE' },
  { value: 'OCE', label: 'OCEAN FREIGHT' },
  { value: '1TON', label: 'ONE TON' },
  { value: 'OP', label: 'OPEN OPTION' },
  { value: 'OT', label: 'OPEN TOP / SCRAP' },
  { value: 'FB45', label: 'OWENS CORNING FB45' },
  { value: 'FB48', label: 'OWENS CORNING FB48' },
  { value: 'UFB4', label: 'OWENS CORNING UFB45' },
  { value: 'PUT', label: 'PICKUP TRAILER' },
  { value: 'PLA', label: 'PLATE VAN TRL' },
  { value: 'NU', label: 'Pneumatic Trailers' },
  { value: 'PD', label: 'POLE DOLLY' },
  { value: 'PO', label: 'POLE TRAILER' },
  { value: 'PUP', label: 'PUP' },
  { value: 'RAIL', label: 'RAIL CAR' },
  { value: 'RV', label: 'Reefer or Vented Van' },
  { value: 'RP', label: 'Reefer Pallet Exchange (DAT)' },
  { value: 'R', label: 'Reefer Trailers' },
  { value: 'REF', label: 'REFRIGERATED VAN' },
  { value: 'RGN', label: 'REMOVEABLE GOOSENECK LOWBOY' },
  { value: 'RCF', label: 'RETRACT CURTAIN FLAT BED' },
  { value: 'SPS', label: 'SINGLE DROP STRETCH' },
  { value: 'SPE', label: 'SPECIALIZED VEHICLE' },
  { value: 'SPRI', label: 'SPRINTER' },
  { value: 'STAC', label: 'STACKED TRAILERS' },
  { value: 'TKST', label: 'STEEL TANK TRAILER' },
  { value: 'STD', label: 'STEERABLE DOLLIES' },
  { value: 'SR', label: 'Step Deck or RGN' },
  { value: 'SP', label: 'STEP DECK/ SINGLE DROP' },
  { value: 'SDD', label: 'STEP OR DOUBLE DROP' },
  { value: 'SN', label: 'Stepdeck Conestoga (DAT)' },
  { value: 'SLT', label: 'STEPDECK LTL' },
  { value: 'SPT', label: 'STEPDECK TEAM' },
  { value: 'SDRA', label: 'STEPDECK WITH RAMPS' },
  { value: 'SDR', label: 'STEPDECK, DOUBLE DROP, OR RGN' },
  { value: 'STIN', label: 'STINGER' },
  { value: 'SB', label: 'Straight Box Truck' },
  { value: 'SBT', label: 'Straight Box Trucks' },
  { value: 'STR', label: 'STRAIGHT TRUCK' },
  { value: 'ST', label: 'STRETCH TRAILER' },
  { value: 'TA', label: 'Tanker Trailers' },
  { value: 'THRU', label: 'THRU TRL' },
  { value: 'TOW', label: 'TOW AWAY' },
  { value: 'TOT', label: 'TOW AWAY TEAM/ POWER ONLY' },
  { value: 'TRA', label: 'TRACTOR ONLY' },
  { value: 'TT', label: 'Truck Tractors' },
  { value: 'UTIL', label: 'UTILITY TRAILER' },
  { value: 'V48', label: 'VAN' },
  { value: 'V53', label: 'VAN' },
  { value: 'VW', label: 'Van Blanket Wrap' },
  { value: 'VZ', label: 'VAN HAZ- MAT' },
  { value: 'VLT', label: 'VAN LTL FREIGHT' },
  { value: 'VFZ', label: 'VAN OR FLAT HAZ-MAT' },
  { value: 'VFWS', label: 'VAN OR FLAT W/ SIDES' },
  { value: 'VR', label: 'VAN OR REEFER' },
  { value: 'VP', label: 'Van Pallet Exchange (DAT)' },
  { value: 'VTM', label: 'VAN TEAM' },
  { value: 'HPLA', label: 'VAN TRAILER WITH HAZMAT PLACARDS' },
  { value: 'V', label: 'Van Trailers' },
  { value: 'VFS', label: 'VAN, FLAT OR STEP' },
  { value: 'BLAD', label: 'WIND BLADE' },
];

export const buchananOrderTypes: ValueLabelOption[] = [
  { value: 'AB', label: 'AB - Anheuser Busch' },
  { value: 'ABREF', label: 'ABREF - Anheuser Busch Reefer' },
  { value: 'AMAZON', label: 'AMAZON - Amazon' },
  { value: 'AO', label: 'AO - ASSET ONLY' },
  { value: 'AOL', label: 'AOL - Asset Only Local' },
  { value: 'BACKHAUL', label: 'BACKHAUL - Backhaul' },
  { value: 'BARGE', label: 'BARGE - BARGES - PERMITTED' },
  { value: 'BARGE-L', label: 'BARGE-L - BARGE - LEGAL' },
  { value: 'BOMVQD', label: 'BOMVQD - Bombardier' },
  { value: 'BT', label: 'BT - Broker Track' },
  { value: 'BTH', label: 'BTH - Broker Track - Hazmat' },
  { value: 'BTP', label: 'BTP - Broker Track -Permitted Load' },
  { value: 'C', label: 'C - Critical' },
  { value: 'CRANE', label: 'CRANE - MEETING CRANE' },
  { value: 'CRITICAL', label: 'CRITICAL - CRITICAL' },
  { value: 'CRPERMIT', label: 'CRPERMIT - Critical Permit' },
  { value: 'CRYSTAL', label: 'CRYSTAL - Crystal Steel' },
  { value: 'DRAY', label: 'DRAY - DRAYAGE' },
  { value: 'E', label: 'E - Entered' },
  { value: 'EXP', label: 'EXP - EXPEDITE ORDER' },
  { value: 'FEDEX', label: 'FEDEX - FEDEX CUSTOM CRITICAL, INC' },
  { value: 'G', label: 'G - GENERAL FREIGHT' },
  { value: 'HAZMAT', label: 'HAZMAT - HAZMAT LOAD' },
  { value: 'HTC', label: 'HTC - High Theft Cargo' },
  { value: 'INGGIN', label: 'INGGIN - Ingersoll Rand' },
  { value: 'LIQUOR', label: 'LIQUOR - LIQUOR SHIPMENT' },
  { value: 'LOCAL', label: 'LOCAL - Local' },
  { value: 'LTL', label: 'LTL - Brokerage LTL order Only' },
  { value: 'METALX', label: 'METALX - Metal X' },
  { value: 'MX', label: 'MX - Mexican Legal Load' },
  { value: 'MXPER', label: 'MXPER - MEXICAN PERMIT LOAD' },
  { value: 'NB', label: 'NB - New Business' },
  { value: 'NPA', label: 'NPA - NO POST - ARCELOR' },
  { value: 'O', label: 'O - Open' },
  { value: 'OPEN', label: 'OPEN - Open' },
  { value: 'PABST', label: 'PABST - PABST BREWING COMPANY' },
  { value: 'PAO', label: 'PAO - PERMIT - ASSET ONLY' },
  { value: 'PERMIT', label: 'PERMIT - PERMIT LOAD' },
  { value: 'POR', label: 'POR - POWER ONLY RETURN' },
  { value: 'POWER', label: 'POWER - POWER ONLY' },
  { value: 'REEFER', label: 'REEFER - REEFER' },
  { value: 'S', label: 'S - S Load' },
  { value: 'S-PER', label: 'S-PER - Permitted S Load' },
  { value: 'SS', label: 'SS - SERVICE SENSITIVE' },
  { value: 'TANKER', label: 'TANKER - TANKER ENDORSEMENT REQUIRED' },
  { value: 'TONU', label: 'TONU - TRUCK ORDER NOT USED' },
];

export const buchananRevenueCodes: ValueLabelOption[] = [
  { value: 'BREP', label: 'BREP' },
  { value: 'BRAG1', label: 'AGENT SELF COVR' },
  { value: 'BRHS1', label: 'BMONT SELF COVR' },
  { value: 'BRAG', label: 'BR - AGENTS' },
  { value: 'BRAL', label: 'BR - ALABAMA' },
  { value: 'BRA', label: 'BR - ARK ASSET' },
  { value: 'BRAR', label: 'BR - ARKANSAS' },
  { value: 'BRV', label: 'BR - AVRAM' },
  { value: 'BRC', label: 'BR - CHICAGO' },
  { value: 'BRCHL', label: 'BR - CHRIS LEE' },
  { value: 'BRD', label: 'BR - DALLAS' },
  { value: 'BREDN', label: 'BR - EDINGER' },
  { value: 'BRF', label: 'BR - FTW103' },
  { value: 'BRFH', label: 'BR - FW HH' },
  { value: 'BRGRE', label: 'BR - GREENVILLE' },
  { value: 'BRH', label: 'BR - HOUSTON HH' },
  { value: 'BRI', label: 'BR - INDY' },
  { value: 'BRIA', label: 'BR - INDY ASSET' },
  { value: 'BRJH', label: 'BR - JACLYN H' },
  { value: 'BRKC', label: 'BR - KANSAS CTY' },
  { value: 'BRMAS', label: 'BR - MASS' },
  { value: 'BRFL', label: 'BR - MIAMI FL' },
  { value: 'BRMP', label: 'BR - Michael P' },
  { value: 'BRM', label: 'BR - MICHIGAN' },
  { value: 'BRO', label: 'BR - ORLANDO' },
  { value: 'BRPHA', label: 'BR - PHNX ASSET' },
  { value: 'BRPH', label: 'BR - PHOENIX' },
  { value: 'BRP', label: 'BR - PITTSBURGH' },
  { value: 'BRR', label: 'BR - REDEEMER' },
  { value: 'BRS', label: 'BR - SATX' },
  { value: 'BRTN', label: 'BR - TENNESSEE' },
  { value: 'BRUHL', label: 'BR - UHL' },
  { value: 'BRVA', label: 'BR - VALPERAISO' },
  { value: 'BRWC', label: 'BR - WC HH' },
  { value: 'BRY', label: 'BR - YOUNGSTOWN' },
  { value: 'BRHS', label: 'BR -BEAUMONT HH' },
  { value: 'BRT', label: 'BR SUGARLAND TX' },
  { value: 'BR74', label: "BRANDON'S TEAM" },
  { value: 'BR', label: 'BROKERAGE' },
  { value: 'OBSC', label: 'COMMITTED SOURC' },
  { value: 'CO', label: 'COMPANY REVENUE' },
  { value: 'MT', label: 'EMPTY MOVE' },
  { value: 'BR72', label: "ERIK'S TEAM" },
  { value: 'GP', label: 'Ghost Post' },
  { value: 'BR76', label: "JACOB'S TEAM" },
  { value: 'BR73', label: "JENNY'S TEAM" },
  { value: 'BMAS1', label: 'MASS SELF COVER' },
  { value: 'MSC', label: 'MISCELLANEOUS' },
  { value: 'ZZB', label: 'NO POST' },
  { value: 'OBB', label: 'No Post Broker' },
  { value: 'OO', label: 'O/O REVENUE' },
  { value: 'ZZZZ', label: 'OO Potential' },
  { value: 'OB', label: 'Our and Broker' },
  { value: 'POSS', label: 'POSSIBLE LOADS' },
  { value: 'POSC', label: 'POSSIBLE SOURCE' },
  { value: 'ZZZ', label: 'POTENTIAL LOAD' },
  { value: 'BR71', label: 'TEAM 11000' },
  { value: 'BR70', label: 'TEAM 12000' },
  { value: 'BR79', label: 'TEAM KELS' },
  { value: 'BR77', label: "TIM'S TEAM" },
  { value: 'TONU', label: 'TONU - DoNotUse' },
  { value: 'TRAIL', label: 'TRAILER DETENT' },
  { value: 'BR75', label: "TREVOR'S TEAM" },
  { value: 'BR78', label: "WADE'S TEAM" },
];

export const buchananCommodityOptions: McleodCommodityOption[] = [
  { code: 'AGRI', description: 'AGRICULTURAL MACHINERY', hazmat: 'N', un: '' },
  { code: 'AIR', description: 'AIR CONDITIONING UNITS', hazmat: '', un: '' },
  { code: 'ALM', description: 'ALUMINUM', hazmat: '', un: '' },
  { code: 'ALC', description: 'ALUMINUM COILS', hazmat: 'N', un: '' },
  { code: 'APL', description: 'APPLIANCES', hazmat: 'N', un: '' },
  { code: 'ARC', description: 'ARCH BLOCK', hazmat: 'N', un: '' },
  { code: 'AUT', description: 'AUTO PARTS', hazmat: '', un: '' },
  { code: 'AXLES', description: 'AXLES', hazmat: 'N', un: '' },
  { code: 'CEMENT', description: 'BAGS OF CEMENT', hazmat: '', un: '' },
  { code: 'BAGS', description: 'BAGS OF SAND', hazmat: '', un: '' },
  { code: 'BAL', description: 'BALERS', hazmat: '', un: '' },
  { code: 'BAR', description: 'BARGES', hazmat: '', un: '' },
  { code: 'BAT', description: 'BATTERIES', hazmat: '', un: '' },
  { code: 'BC', description: 'BEDDING COMPONENTS', hazmat: 'N', un: '' },
  { code: 'BEER', description: 'BEER', hazmat: 'N', un: '' },
  {
    code: 'BEV',
    description: 'BEVERAGES  NON - ALCOHOLIC',
    hazmat: '',
    un: '',
  },
  { code: 'BIL', description: 'BILLETS', hazmat: '', un: '' },
  { code: 'BOAT', description: 'BOAT TRAILERS', hazmat: '', un: '' },
  { code: 'BOOM', description: 'BOOM LIFT', hazmat: '', un: '' },
  { code: 'BOT', description: 'BOTTLES', hazmat: '', un: '' },
  { code: 'BRS', description: 'BRASS', hazmat: 'N', un: '' },
  { code: 'BRI', description: 'BRICK', hazmat: '', un: '' },
  { code: 'BUILD', description: 'BUILDING PRODUCTS', hazmat: '', un: '' },
  { code: 'BUILDINGS', description: 'BUILDINGS', hazmat: 'N', un: '' },
  { code: 'CABLE', description: 'CABLE ON REELS', hazmat: 'N', un: '' },
  { code: 'CAB', description: 'CABLE TRAYS', hazmat: '', un: '' },
  { code: 'CAGE', description: 'Cages', hazmat: 'N', un: '' },
  { code: 'CARD', description: 'CARDBOARD', hazmat: 'N', un: '' },
  { code: 'CTILE', description: 'CEILING TILE', hazmat: 'N', un: '' },
  { code: 'CEPT', description: 'CELL PHONE TOWERS', hazmat: 'N', un: '' },
  { code: 'CHA', description: 'CHASSIS', hazmat: '', un: '' },
  { code: 'CHEMICAL', description: 'CHEMICAL PRODUCTS', hazmat: 'N', un: '' },
  {
    code: 'SKEET',
    description: 'Clay targets for Skeet Shooting',
    hazmat: 'N',
    un: '',
  },
  { code: 'CLEANING', description: 'CLEANING SUPPLIES', hazmat: 'N', un: '' },
  { code: 'COILS', description: 'COILS', hazmat: 'N', un: '' },
  {
    code: 'CONBEAMS',
    description: 'CONCRETE BRIDGE BEAMS',
    hazmat: 'N',
    un: '',
  },
  { code: 'CONDECK', description: 'CONCRETE DECK SLABS', hazmat: 'N', un: '' },
  { code: 'CONCRET', description: 'CONCRETE FORMS', hazmat: '', un: '' },
  { code: 'CONPILING', description: 'CONCRETE PILING', hazmat: 'N', un: '' },
  { code: 'CONS', description: 'CONSTRUCTION EQUIPMENT', hazmat: '', un: '' },
  { code: 'CONSTM', description: 'CONSTRUCTION MATERIAL', hazmat: '', un: '' },
  { code: 'CNTNR', description: 'CONTAINER', hazmat: '', un: '' },
  {
    code: 'CONT',
    description: 'CONTAINER (NEW/USED/REPOSITIONED)',
    hazmat: '',
    un: '',
  },
  { code: 'CONV', description: 'CONVEYOR', hazmat: '', un: '' },
  { code: 'COPPER', description: 'COPPER', hazmat: 'N', un: '' },
  { code: 'COP', description: 'COPPER BARS', hazmat: '', un: '' },
  { code: 'COPSH', description: 'COPPER SHEETS', hazmat: '', un: '' },
  { code: 'CRA PARTS', description: 'CRANE PARTS', hazmat: '', un: '' },
  { code: 'CRA', description: 'CRATES', hazmat: '', un: '' },
  { code: 'DIE', description: 'DIES / MOLDS', hazmat: '', un: '' },
  { code: 'LAUN', description: 'DO NOT  USE', hazmat: '', un: '' },
  { code: 'OILD', description: 'DO NOT  USE', hazmat: '', un: '' },
  { code: 'IRM', description: 'DO NOT UPDATE', hazmat: '', un: '' },
  { code: 'PAPAP', description: 'DO NOT UPDATE', hazmat: 'N', un: '' },
  { code: 'PAPGOOD', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'PAPROLL', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'NICPLA', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'NOP', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'OD', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PHA', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PHR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PICKUP', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PBS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PC', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PLA', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PLABOT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PLANTER', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PLASCON', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'PLASTICDR', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'PLASTICS', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'PLATI', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PLB', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PLF', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PLP', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PLY', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PM', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PO', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'POU', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PRESS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PRI', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'RAC', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'RAGS', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'REGRIND', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'REPCON', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'RES', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'RET', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'RETARDERS', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'REVERT', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'RAILR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'RAK', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'RAW', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'ROB', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'ROC', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'ROD', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SKF', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SKI', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SKS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SLATE', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SLOT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SMF', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SNA', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SOAP', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SOD', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SOFT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SEAL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SEED', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SHE', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SHIWIR', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'SHO', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SHOT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SHOW', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'ROTOR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'RPP', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'RR', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'RRM', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'RRT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'RUB', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'RUBHOSE', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'RWALL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SAM', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SAND', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'SCK', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SCR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SIL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'STBL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'STBUND', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'STCA', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'STCON', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'STDK', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'STECRO', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'STEEL', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'STEEP', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'STEP', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'STJ', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'STLP', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'STLW', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'STNP', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'STO BOX', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'STONE', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'STUCCO', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'STW', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'STY', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SUG', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SUNFL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SWIT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'SWS', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'SYNLUM', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TANL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TBRI', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TCN', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TEL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TEN', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TEX', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TILE', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'STP', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'STR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'STRFIX', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TIT PLA', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TOI', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TOILPAP', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'STS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'STSH', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TRAC', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TRACK', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TRAM', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TRAN', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TRAX', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TRE', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TRF', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TRK', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TRON', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TUBST', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TUR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TWR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TRR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'TRUCKBEDS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'VAL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'VEH', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'VET', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'VL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'WALL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'WAX', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'WF', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'WHE', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'WAT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'WIRE', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'WOOD', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'WRA', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'WTRH', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'YOLK', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'ZINC', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'IRON', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'ISO', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'ISOTANK', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'HAIR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'HARD', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'HAY', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'HST', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'HUB', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'HUM', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'HW', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'HYD', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'ICEMT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'LAT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'LATE', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'LAU', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'KEG', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'KNIFETAP', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'LADDERS', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'LIF', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'LIG', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'LIGHT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'LIGHTBULB', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'LIME', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'LIN', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'LINERS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'LOB', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'LOGS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'LOUV', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'OILEQ', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'ONO', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'OUT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'OVEN', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'PA', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'MILR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'MIN', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'MUDCOM', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'NAI', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'MAIL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'MAS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'MECH PART', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'MET', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'METBD', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'MATT', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'METSL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'MGT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'MIX', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'MOLD', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'MOT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'MOTOR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'MOTORS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'MTDRUMS', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'EMPTY', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'EMPTYTOTE', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'END', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'ELE', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'ENGINE', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'ENV', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'EQUIP', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'EREEL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'ETP', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'EXT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'FAB', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'FABS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'FAN', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'FARMEQ', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'FAST', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'FEE', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'FENCE', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'FIB', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'FIBER', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'FIBEROPTI', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'FILM', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'FIREBR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'FIT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'FIX', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'FLB', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'FLOORING', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'FOR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'FRAAL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'FRAME', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'FRAMEKITS', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'FRATNK', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'FUAC', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'FURN', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'FURNT', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'FUTONS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'G2-20', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'G2-32', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'GAT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'GEBX', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'GLUE', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'GMC', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'GOLF', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'GRA', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'GRI', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'GRIBLS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'GRO', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'HEA', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'HEAD', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'HEAT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'HEE', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'HELI', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'HHG', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'HON', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'HOP', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'HOPPER', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'HOSP', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'DIS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'DOL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'DOZ', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'DRI', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'DRM', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'DRYER', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'DRYWA', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'DRYWALL', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'DUMP', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'DUN', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'DUST', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'COPS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'COR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CORN', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'COT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CPNT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CPT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CRAN', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CRNS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CRS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CRTNS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CTOOL', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'CUP', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CX', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CYC', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CYL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'DEHUM', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CONVEYORS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'COO', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CONSU', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CONGOODS', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'CONC', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CONCR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CHI', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CLA', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'COF', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'COI', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'COI WIRE', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'COKECOLA', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'COM', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'COMB', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'COMBINE', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'COMP', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CON', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CLEANSUP', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'CLO', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CLOTH', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'CLR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CMAT', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CNC', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CHAR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CARPET', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'CARS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CARTS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CAS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CASTIRON', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'CAX', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CB', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CBL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CAIR', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'CAL', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CANDY', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CANGD', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'CAPS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'CAR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BSKID', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BUI', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BOX', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BRA', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BRGR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BOOTH', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BLE', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BLO', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BOARDER', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BOC', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'BOI', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BOMB', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BOOK', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BIN', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BIR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BIRD', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BEA', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BEAN', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BED', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'BAS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BAK', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BAC', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BACK', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'BAG', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'ARTTURF', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'ASBLY', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'ATV', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'APP', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'ALS', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'AMMO', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'ACH', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'AGSYRUP', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'AIR COMPR', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'AIR FILTE', description: 'DO NOT USE', hazmat: '', un: '' },
  { code: 'AIRFIL', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'AIRU', description: 'DO NOT USE', hazmat: 'N', un: '' },
  { code: 'DRAI', description: 'DRAINAGE', hazmat: 'N', un: '' },
  { code: 'DPIPE', description: 'DRAINAGE PIPE', hazmat: 'N', un: '' },
  { code: 'DRUMS', description: 'DRUMS', hazmat: 'N', un: '' },
  { code: 'DRY', description: 'DRY GOODS', hazmat: '', un: '' },
  { code: 'DUCT', description: 'DUCTWORK', hazmat: '', un: '' },
  { code: 'EGGS', description: 'Eggs', hazmat: 'N', un: '' },
  { code: 'ELEV', description: 'ELEVATOR PARTS', hazmat: 'N', un: '' },
  {
    code: 'NA1993',
    description: 'Emiulsion Breaker 01550',
    hazmat: 'Y',
    un: 'NA1993',
  },
  { code: 'BOTTLES', description: 'EMPTY BOTTLES', hazmat: '', un: '' },
  { code: 'EMP', description: 'EMPTY REELS', hazmat: '', un: '' },
  { code: 'ENG', description: 'ENGINE', hazmat: '', un: '' },
  { code: 'ENGS', description: 'ENGINE STANDS', hazmat: 'N', un: '' },
  { code: 'EXC', description: 'EXCAVATOR', hazmat: '', un: '' },
  { code: 'FENDERS', description: 'FENDERS', hazmat: 'N', un: '' },
  { code: 'FERT', description: 'FERTILIZER', hazmat: '', un: '' },
  {
    code: 'FIBCEMENT',
    description: 'FIBER CEMENT SIDING',
    hazmat: 'N',
    un: '',
  },
  { code: 'FIBERDRUM', description: 'FIBER DRUMS', hazmat: 'N', un: '' },
  { code: 'FLO', description: 'FLOUR', hazmat: 'N', un: '' },
  { code: 'FOA', description: 'FOAM', hazmat: '', un: '' },
  { code: 'FOOD', description: 'FOOD OR GROCERY', hazmat: 'N', un: '' },
  { code: 'FORKPART', description: 'FORK LIFT PARTS', hazmat: 'N', un: '' },
  { code: 'FORK', description: 'FORKLIFT', hazmat: '', un: '' },
  { code: 'FRA', description: 'FRAMES', hazmat: '', un: '' },
  { code: 'FAK', description: 'FREIGHT OF ALL KINDS', hazmat: 'N', un: '' },
  { code: 'FUR', description: 'FURNITURE', hazmat: '', un: '' },
  { code: 'GALV', description: 'GALVANIZED STEEL', hazmat: 'N', un: '' },
  { code: 'GSTEEL', description: 'Galvanized steel', hazmat: 'N', un: '' },
  { code: 'GAY', description: 'GAYLORDS', hazmat: 'N', un: '' },
  { code: 'GEN', description: 'GENERATORS', hazmat: '', un: '' },
  { code: 'GLA', description: 'GLASS & GLASS PRODUCTS', hazmat: '', un: '' },
  { code: 'GREEN', description: 'GREENHOUSE MATERIAL', hazmat: 'N', un: '' },
  {
    code: 'HAZMAT',
    description: 'HAZARDOUS CHEMICALS',
    hazmat: 'Y',
    un: 'UN2035',
  },
  { code: 'UN1044', description: 'Hazmat UN1044', hazmat: 'Y', un: 'UN1044' },
  { code: 'UN1049', description: 'Hazmat UN1049', hazmat: 'Y', un: 'UN1049' },
  { code: 'UN1075', description: 'Hazmat UN1075', hazmat: 'Y', un: 'UN1075' },
  { code: 'UN1133', description: 'Hazmat UN1133', hazmat: 'Y', un: 'UN1133' },
  { code: 'UN1170', description: 'Hazmat UN1170', hazmat: 'Y', un: 'UN1170' },
  { code: 'UN1203', description: 'Hazmat UN1203', hazmat: 'Y', un: 'UN1203' },
  { code: 'UN1268', description: 'Hazmat UN1268', hazmat: 'Y', un: 'UN1268' },
  { code: 'UN1759', description: 'Hazmat UN1759', hazmat: 'Y', un: 'UN1759' },
  { code: 'UN1760', description: 'Hazmat UN1760', hazmat: 'Y', un: 'UN1760' },
  { code: 'UN1789', description: 'Hazmat UN1789', hazmat: 'Y', un: 'UN1789' },
  { code: 'UN1790', description: 'Hazmat UN1790', hazmat: 'Y', un: 'UN1790' },
  { code: 'UN1866', description: 'Hazmat UN1866', hazmat: 'Y', un: 'UN1866' },
  { code: 'UN1908', description: 'Hazmat UN1908', hazmat: 'Y', un: 'UN1908' },
  { code: 'UN1993', description: 'Hazmat UN1993', hazmat: 'Y', un: 'UN1993' },
  { code: 'UN2014', description: 'Hazmat UN2014', hazmat: 'Y', un: 'UN2014' },
  { code: 'UN2051', description: 'Hazmat UN2051', hazmat: 'Y', un: 'UN2051' },
  { code: 'UN2078', description: 'Hazmat UN2078', hazmat: 'Y', un: 'UN2078' },
  { code: 'UN2443', description: 'Hazmat UN2443', hazmat: 'Y', un: 'UN2443' },
  { code: 'UN2586', description: 'Hazmat UN2586', hazmat: 'Y', un: 'UN2586' },
  { code: 'UN2608', description: 'Hazmat UN2680', hazmat: 'Y', un: 'UN2680' },
  { code: 'UN2735', description: 'Hazmat UN2735', hazmat: 'Y', un: 'UN2735' },
  { code: 'UN2784', description: 'Hazmat UN2784', hazmat: 'Y', un: 'UN2784' },
  { code: 'UN2794', description: 'Hazmat UN2794', hazmat: 'Y', un: 'UN2794' },
  { code: 'UN2810', description: 'Hazmat UN2810', hazmat: 'Y', un: 'UN2810' },
  { code: 'UN2811', description: 'Hazmat UN2811', hazmat: 'Y', un: 'UN2811' },
  { code: 'UN2878', description: 'Hazmat UN2878', hazmat: 'Y', un: 'UN2878' },
  { code: 'UN2922', description: 'Hazmat UN2922', hazmat: 'Y', un: 'UN2922' },
  { code: 'UN3077', description: 'Hazmat UN3077', hazmat: 'Y', un: 'UN3077' },
  { code: 'UN3082', description: 'Hazmat UN3082', hazmat: 'Y', un: 'UN3082' },
  { code: 'UN3148', description: 'Hazmat UN3148', hazmat: 'Y', un: 'UN3148' },
  { code: 'UN3163', description: 'Hazmat UN3163', hazmat: 'Y', un: 'UN3163' },
  { code: 'UN3190', description: 'Hazmat UN3190', hazmat: 'Y', un: 'UN3190' },
  { code: 'UN3192', description: 'Hazmat UN3192', hazmat: 'Y', un: 'UN3192' },
  { code: 'UN3259', description: 'Hazmat UN3259', hazmat: 'Y', un: 'UN3259' },
  { code: 'UN3260', description: 'Hazmat UN3260', hazmat: 'Y', un: 'UN3260' },
  { code: 'UN3265', description: 'Hazmat UN3265', hazmat: 'Y', un: 'UN3265' },
  { code: 'UN3288', description: 'Hazmat UN3288', hazmat: 'Y', un: 'UN3288' },
  { code: 'UN3320', description: 'Hazmat UN3320', hazmat: 'Y', un: 'UN3320' },
  { code: 'UN3393', description: 'Hazmat UN3393', hazmat: 'Y', un: 'UN3393' },
  { code: 'UN3399', description: 'Hazmat UN3399', hazmat: 'Y', un: 'UN3399' },
  { code: 'UN3480', description: 'Hazmat UN3480', hazmat: 'Y', un: 'UN3480' },
  { code: 'UN3500', description: 'Hazmat UN3500', hazmat: 'Y', un: 'UN3500' },
  { code: 'HOT', description: 'HOT TUBS', hazmat: '', un: '' },
  { code: 'ING', description: 'INGOTS', hazmat: '', un: '' },
  {
    code: 'INSU',
    description: 'INSULATED BUILDING PRODUCTS',
    hazmat: 'N',
    un: '',
  },
  { code: 'INS', description: 'INSULATION MATERIALS', hazmat: '', un: '' },
  { code: 'JOS', description: 'JOIST & DECKING', hazmat: '', un: '' },
  { code: 'LAD', description: 'LADDERS', hazmat: 'N', un: '' },
  { code: 'LAN', description: 'LANDSCAPE MATERIAL', hazmat: '', un: '' },
  { code: 'LAZ', description: 'LAZER TAG ARENA', hazmat: 'N', un: '' },
  { code: 'LUM', description: 'LUMBER', hazmat: '', un: '' },
  { code: 'MAC', description: 'MACHINERY', hazmat: '', un: '' },
  {
    code: 'MANU',
    description: 'MANUFACTURED PRODUCTS MISC',
    hazmat: 'N',
    un: '',
  },
  { code: 'MAT', description: 'MATS', hazmat: '', un: '' },
  { code: 'METCAS', description: 'METAL CASTINGS', hazmat: 'N', un: '' },
  { code: 'METCON', description: 'METAL CONTAINERS', hazmat: 'N', un: '' },
  { code: 'MTP', description: 'MILITARY TRANSFER PARTS', hazmat: 'N', un: '' },
  { code: 'MIL', description: 'MILITARY TRUCK', hazmat: '', un: '' },
  { code: 'MISC', description: 'MISCELLANEOUS', hazmat: '', un: '' },
  { code: 'MB', description: 'MOLYBDENUM', hazmat: 'N', un: '' },
  { code: 'MUL', description: 'MULCH', hazmat: '', un: '' },
  { code: 'NEW', description: 'NEW BUS PARTS', hazmat: '', un: '' },
  {
    code: 'NONHAZ',
    description: 'NON HAZARDOUS CHEMICALS',
    hazmat: '',
    un: '',
  },
  { code: 'OIL', description: 'OIL MISC.', hazmat: '', un: '' },
  { code: 'PAC', description: 'PACKAGING', hazmat: '', un: '' },
  { code: 'PF', description: 'PALLETIZED FREIGHT', hazmat: '', un: '' },
  {
    code: 'POS',
    description: 'Palletized Office Supplies',
    hazmat: 'N',
    un: '',
  },
  { code: 'PETFOOD', description: 'PALLETIZED PET FOOD', hazmat: 'N', un: '' },
  { code: 'WATER', description: 'PALLETIZED WATER', hazmat: 'N', un: '' },
  {
    code: 'PWFP',
    description: 'PALLETIZED WATER FILTRATION PRODUCTS',
    hazmat: 'N',
    un: '',
  },
  { code: 'PAL', description: 'PALLETS', hazmat: '', un: '' },
  { code: 'PAP', description: 'PAPER', hazmat: '', un: '' },
  { code: 'PAR', description: 'PARTS', hazmat: '', un: '' },
  { code: 'PIP', description: 'PIPE', hazmat: '', un: '' },
  { code: 'PLAS', description: 'PLASTIC', hazmat: '', un: '' },
  { code: 'PLAT', description: 'PLATES', hazmat: '', un: '' },
  { code: 'PL', description: 'PLATES', hazmat: '', un: '' },
  { code: 'POL', description: 'POLE', hazmat: '', un: '' },
  { code: 'POW', description: 'POWDERED DRINK MIX', hazmat: '', un: '' },
  { code: 'PREC', description: 'PRECAST', hazmat: 'N', un: '' },
  { code: 'PRE', description: 'PRESS', hazmat: '', un: '' },
  { code: 'PRO', description: 'PRODUCTION', hazmat: '', un: '' },
  { code: 'PUM', description: 'PUMPS', hazmat: '', un: '' },
  { code: 'RACK', description: 'RACKS', hazmat: '', un: '' },
  { code: 'RAD', description: 'RADIATORS', hazmat: '', un: '' },
  { code: 'RAIL', description: 'RAIL', hazmat: '', un: '' },
  { code: 'RAILCOV', description: 'RAIL CAR COVERS', hazmat: 'N', un: '' },
  { code: 'RAILCAR', description: 'RAILCAR', hazmat: '', un: '' },
  { code: 'RLRT', description: 'RAILROAD TIES', hazmat: '', un: '' },
  { code: 'REB', description: 'REBAR', hazmat: '', un: '' },
  { code: 'SCRAP', description: 'Recycled Scrap Metal', hazmat: 'N', un: '' },
  { code: 'REFRACT', description: 'REFRACTORY MATERIAL', hazmat: 'N', un: '' },
  { code: 'REF', description: 'REFREIGERATION UNITS', hazmat: 'N', un: '' },
  { code: 'RLZ', description: 'RLZ Fleet Serivices', hazmat: 'N', un: '' },
  { code: 'ROF', description: 'ROOFING MATERIALS', hazmat: '', un: '' },
  { code: 'SA', description: 'SALT', hazmat: '', un: '' },
  { code: 'SCA', description: 'SCAFFOLDING', hazmat: '', un: '' },
  { code: 'SCI', description: 'SCISSOR LIFT', hazmat: '', un: '' },
  {
    code: 'STOPNOTES',
    description: 'SEE STOP INSTRUCTIONS',
    hazmat: 'N',
    un: '',
  },
  { code: 'SHI', description: 'SHINGLES', hazmat: '', un: '' },
  { code: 'SIGN', description: 'SIGN', hazmat: '', un: '' },
  { code: 'SKC', description: 'SKIDDED COILS', hazmat: '', un: '' },
  { code: 'SPA', description: 'SPAS', hazmat: '', un: '' },
  { code: 'SPUD', description: 'SPUDS', hazmat: '', un: '' },
  { code: 'STK TR', description: 'STACKED TRAILERS', hazmat: '', un: '' },
  { code: 'GENSTL', description: 'STEEL (IN GENERAL)', hazmat: '', un: '' },
  { code: 'STB', description: 'STEEL BARS', hazmat: '', un: '' },
  { code: 'STE', description: 'STEEL BEAMS', hazmat: '', un: '' },
  { code: 'SDI', description: 'STEEL BEAMS', hazmat: '', un: '' },
  { code: 'STC', description: 'STEEL COILS', hazmat: '', un: '' },
  { code: 'STEELDRUM', description: 'STEEL DRUMS', hazmat: 'N', un: '' },
  { code: 'PIPE', description: 'STEEL PIPE', hazmat: '', un: '' },
  { code: 'STEPLA', description: 'STEEL PLATES', hazmat: '', un: '' },
  { code: 'SPL', description: 'STEEL PLATES', hazmat: '', un: '' },
  { code: 'SLP', description: 'STEEL POLES', hazmat: '', un: '' },
  { code: 'SSH', description: 'STEEL SHEETS', hazmat: '', un: '' },
  { code: 'STT', description: 'STEEL TUBING', hazmat: '', un: '' },
  { code: 'STN', description: 'STONE', hazmat: '', un: '' },
  { code: 'STRL', description: 'STRUCTURAL STEEL', hazmat: 'N', un: '' },
  { code: 'TAN', description: 'TANKS', hazmat: '', un: '' },
  { code: 'TIRE', description: 'TIRES', hazmat: '', un: '' },
  { code: 'TOOL', description: 'TOOL BOXES', hazmat: 'N', un: '' },
  { code: 'TOL', description: 'TOOLS, POWERED HAND TOOLS', hazmat: '', un: '' },
  { code: 'TOT', description: 'TOTES', hazmat: '', un: '' },
  { code: 'TOW', description: 'TOW AWAY', hazmat: '', un: '' },
  { code: 'TRP', description: 'TRACTOR PARTS', hazmat: '', un: '' },
  { code: 'TRA', description: 'TRACTORS', hazmat: '', un: '' },
  { code: 'TRAA', description: 'TRAILER ACCESSORIES', hazmat: '', un: '' },
  { code: 'TREC', description: 'TRAILER RECOVERY', hazmat: 'N', un: '' },
  { code: 'TRAI', description: 'Trailers', hazmat: '', un: '' },
  { code: 'TRANSFORM', description: 'TRANSFORMERS', hazmat: '', un: '' },
  { code: 'TRU', description: 'TRUCK', hazmat: '', un: '' },
  { code: 'TONU', description: 'TRUCK ORDER NOT USED', hazmat: 'N', un: '' },
  { code: 'TUB', description: 'TUBING', hazmat: '', un: '' },
  {
    code: 'WARHAZ',
    description: 'WARSAW HAZMAT PRODUCTS',
    hazmat: 'Y',
    un: '',
  },
  { code: 'WS', description: 'Wheelsets', hazmat: 'N', un: '' },
  { code: 'BLADE', description: 'WINDMILL BLADES', hazmat: '', un: '' },
  { code: 'WIR', description: 'WIRE ROD COIL', hazmat: '', un: '' },
  { code: 'WOODPOLE', description: 'WOOD UTILITY POLES', hazmat: 'N', un: '' },
];

export const buchananReferenceNumberOptions: McleodReferenceNumberOption[] = [
  { description: 'Acceptable Source DUNS Number', code: 'AD' },
  { description: 'Account Number', code: '11' },
  { description: 'Accounting (Equipment) Location Number', code: 'AL' },
  { description: 'Accounts Receivable Number', code: 'AP' },
  { description: 'Advertiser Number', code: 'A0' },
  { description: 'Appointment Number', code: 'AO' },
  { description: 'Assembly Line Feed Location', code: 'LF' },
  { description: 'Associated Invoices', code: 'AI' },
  { description: 'Associated Purchase Orders', code: 'AN' },
  { description: 'Authorization to Meet Competition Number', code: 'AU' },
  { description: 'Axle Ratio', code: 'B2' },
  { description: 'Batch Number', code: 'BT' },
  { description: 'Bill of Lading Number', code: 'BM' },
  { description: 'Booking Number', code: 'BN' },
  { description: "Broker's Reference Number", code: 'WT' },
  { description: "Buyer's Approval Mark", code: 'BU' },
  { description: "Buyer's Contract Number", code: 'BC' },
  { description: "Carrier's Reference Number (PRO/Invoice)", code: 'CN' },
  { description: 'Casualty Report Number', code: 'CRN' },
  { description: 'Check Number', code: 'CK' },
  { description: 'Class Code', code: 'ACD' },
  { description: 'Clear Text Clause', code: 'CU' },
  { description: 'Condition of Purchase Document Number', code: 'CP' },
  { description: 'Condition of Sale Document Number', code: 'CS' },
  { description: "Consignee's Order Number", code: 'CG' },
  { description: 'Consolidation Shipment Number', code: '1O' },
  { description: 'Container/Packaging Specification Number', code: '98' },
  { description: 'Contract Number', code: 'CT' },
  { description: 'Contract Reference', code: 'KL' },
  { description: 'Cost Allocation Reference', code: 'CA' },
  { description: 'Creditor', code: 'J1' },
  { description: 'Cross Reference Number', code: '6O' },
  { description: 'Customer Order Number', code: 'CO' },
  { description: 'Customer Reference Number', code: 'CR' },
  { description: "Customer's Release Number", code: 'L7' },
  { description: 'Data Reliability Code', code: 'D0' },
  { description: 'Dealer Order Number', code: 'ON' },
  { description: 'Dealer purchase order number', code: 'DC' },
  { description: 'Delivery Order Number', code: 'DO' },
  { description: 'Delivery Quote Number', code: 'DQ' },
  { description: 'Delivery Reference', code: 'KK' },
  { description: 'Delivery Ticket Number', code: 'DJ' },
  { description: 'Department Number', code: 'DP' },
  {
    description: 'Department of Labor Acquisition Regulation (DOLAR)',
    code: 'DOL',
  },
  { description: 'Departure from Specification Number', code: 'DSI' },
  { description: 'Distributor Invoice Number', code: 'DI' },
  { description: 'District Number', code: 'DIS' },
  { description: 'Dock Number', code: 'DK' },
  { description: 'Document Identification Code', code: 'DD' },
  { description: 'Domicile Branch Number', code: 'DA' },
  { description: 'Draft Number', code: 'DN' },
  { description: 'Drug Formulary Number', code: 'FO' },
  { description: 'Electronic device pin number', code: 'EL' },
  { description: "End User's Purchase Order Number", code: 'EU' },
  { description: 'Equipment Initial', code: '6Y' },
  { description: 'Equipment Number', code: 'EQ' },
  { description: 'Exhibit Identifier', code: 'GO' },
  { description: 'Export Reference Number', code: 'RF' },
  {
    description: 'Federal Maritime Commission (FMC) Tariff Number',
    code: 'TE',
  },
  { description: 'Film Number', code: 'FF' },
  { description: 'Financial Classification Code', code: 'EH' },
  { description: 'Freight Payor Reference Number', code: 'F9' },
  { description: 'Government Bill of Lading', code: 'BL' },
  { description: 'Heat Code', code: 'HC' },
  { description: 'Inbound-to or Outbound-from Party', code: 'IO' },
  { description: 'Insurance Certificate Number', code: 'ID' },
  { description: 'Internal Customer Number', code: 'IT' },
  { description: 'Internal Vendor Number', code: 'IA' },
  { description: 'Intra Plant Routing', code: 'IR' },
  { description: 'Invoice Number', code: 'IK' },
  { description: 'Invoice Number Suffix', code: 'IS' },
  { description: 'Item Number', code: 'IX' },
  { description: 'Latitude Expressed in Seconds', code: 'LL' },
  { description: 'Letter of Credit Number', code: 'NB' },
  { description: 'Load Planning Number', code: 'LO' },
  { description: 'Loan Acquisition Number', code: 'GM' },
  { description: 'Loan Number', code: 'LD' },
  { description: 'Lot Number', code: 'LT' },
  { description: 'Master Bill of Lading', code: 'MB' },
  { description: 'Merchandise Type Code', code: 'MR' },
  { description: 'Mill Order Number', code: 'MI' },
  { description: 'Model Number', code: 'MJ' },
  { description: 'Motor Vehicle ID Number', code: 'VT' },
  { description: 'Mutually Defined', code: 'ZZ' },
  { description: 'National Stock Number', code: 'NS' },
  { description: 'Non pickup Limited Tariff Number', code: 'LN' },
  { description: 'Ocean Bill of Lading', code: 'OB' },
  { description: 'Offer Group', code: 'OK' },
  { description: 'Order Number', code: 'OQ' },
  { description: 'Order/Paragraph Number', code: 'OR' },
  { description: 'Original Invoice Number', code: 'OI' },
  { description: 'Original Purchase Order', code: 'OP' },
  { description: 'Originating Company Identifier', code: '8M' },
  { description: 'Outer Continental Shelf Area Code', code: 'O1' },
  { description: 'Outer Continental Shelf Block Number', code: 'O2' },
  {
    description:
      "Payee's Financial Institution Account Number for Check, Draft or Wire Payments",
    code: 'PY',
  },
  {
    description:
      "Payee's Financial Institution Transit Routing Number for Check, Draft or Wire",
    code: 'RT',
  },
  { description: 'Permit Number', code: 'PN' },
  { description: 'Pickup Reference Number', code: 'P8' },
  { description: 'Plant Number', code: 'PE' },
  { description: 'Policy Number', code: 'POL' },
  { description: 'Previous Bill of Lading Number', code: 'PU' },
  { description: 'Price Area Number', code: 'PA' },
  { description: 'Price List Change or Issue Number', code: 'PI' },
  { description: 'Price Quote Number', code: 'PR' },
  { description: 'Prior purchase order number', code: 'PW' },
  { description: 'Product Specification Document Number', code: 'QC' },
  { description: 'Purchase Order Number', code: 'PO' },
  { description: 'Purchase Order Number Suffix', code: 'PS' },
  { description: 'Purchase Order Number Suffix', code: 'PS' },
  { description: 'Purchase Order Revision Number', code: 'PP' },
  { description: 'Purchase Requisition Number', code: 'RQ' },
  { description: 'Quality Inspection Area Identifier', code: 'QI' },
  { description: 'Quote Number', code: 'Q1' },
  { description: 'Rate code number', code: 'RB' },
  { description: 'Receiving Number', code: 'RV' },
  { description: 'Referenced By', code: '0L' },
  { description: 'Relay Payment Services', code: 'RP' },
  { description: 'Release invoice number for prior bill and hold', code: 'RI' },
  { description: 'Release Number', code: 'RE' },
  { description: 'Repetitive Booking Number', code: 'RO' },
  { description: 'Repetitive Cargo Shipment Number', code: 'RA' },
  { description: 'Response to a Request for Quotation Reference', code: 'KR' },
  { description: 'Run Number', code: 'RN' },
  { description: 'Safety of Ship Certificate', code: 'Z1' },
  { description: 'Sales Office Number', code: 'SM' },
  { description: 'Sales Program Number', code: 'QK' },
  { description: 'Sales Region Number', code: 'SB' },
  { description: 'Sales Responsibility', code: 'SR' },
  { description: 'Salesperson', code: 'SA' },
  { description: 'Scan Line', code: 'SP' },
  { description: 'Seal Number', code: 'SN' },
  { description: 'Seal On Number', code: 'S9' },
  { description: 'Secondary Coverage Company Number', code: 'NC' },
  { description: "Seller's Credit Memo", code: 'CL' },
  {
    description:
      'Sending Company Audit Number (Automated Clearinghouse Transfers)',
    code: 'AK',
  },
  { description: 'Serial Number', code: 'SE' },
  { description: 'Service Authorization Number', code: 'QL' },
  { description: 'Service Change Number', code: 'SK' },
  { description: 'Service Estimate Number', code: 'QO' },
  { description: 'Shipment Origin Code', code: '4B' },
  {
    description: "Shipper's Identifying Number for Shipment (SID)",
    code: 'SI',
  },
  { description: "Shipper's Order (Invoice Number)", code: 'SO' },
  { description: 'Shipping Zone', code: '4D' },
  { description: 'Special Processing Code', code: 'SU' },
  { description: 'Standard Carrier Alpha Code (SCAC)', code: 'SCA' },
  { description: 'Stop Sequence Number', code: 'QN' },
  { description: 'Store Number', code: 'ST' },
  { description: 'Subday Number', code: 'SD' },
  { description: 'Subhouse Bill of Lading', code: '4Y' },
  { description: 'Tariff Supplement Number', code: 'OU' },
  { description: 'Technical Documentation Type', code: 'TDT' },
  { description: 'Terminal Operator Number', code: 'TO' },
  { description: 'Termination Filing', code: 'OG' },
  { description: 'Transaction Reference Number', code: 'TN' },
  { description: 'Transportation Account Code (TAC)', code: 'TH' },
  { description: 'Travel Manifest (ACI or OTR)', code: 'TM' },
  { description: 'Unacceptable Source Supplier ID', code: 'US' },
  { description: 'Unique Consignment Identifier', code: 'CI' },
  { description: 'Unit Number', code: 'QQ' },
  { description: 'United Nations Hazardous Classification Number', code: 'UN' },
  { description: 'Upstream Shipper Contract Number', code: 'UP' },
  { description: 'Vendor Abbreviation Code', code: 'VE' },
  { description: 'Version', code: 'V0' },
  { description: 'Volume Number', code: 'VD' },
  { description: 'Waiver', code: 'WI' },
  { description: 'Ward', code: 'VM' },
];
